export default __webpack_public_path__ + "static/media/link1.ae09f086.png";